export const getSignalLoading = (state) => {
    return state.loading
}

export const getSignal = (state) => {
    return state.signals
}

export const getSignalStatus = (state) => {
    return state.signalStatus
}

export const getSignalDetail = (state) => {
    return state.signalDetail
}

export const getPostponeSignals = (state) => {
    return state.postponeSignals
}



// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Signal/Getters.js